<template>
  <a-modal
    v-model="visible"
    title="添加跟进记录"
    @ok="handleOk"
    @cancel="handleClose"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
  >
    <a-form-model ref="ruleForm" :model="form" :rules="rules">
      <a-form-model-item label="请输入跟进记录内容" prop="content">
        <a-textarea v-model="form.content" :rows="3" placeholder="请输入内容" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        costomer_id: "",
        content: "",
      },
      submitLoading: false,
      rules: {
        content: [
          {
            required: true,
            message: "请输入跟进记录",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    init(costomer_id) {
      this.form.costomer_id = costomer_id;
      this.visible = true;
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: "/admin/followlog/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success("添加跟进记录成功");
              this.handleClose();
              this.$emit("followok");
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
  },
};
</script>

<style>
</style>